import * as React from 'react';
import { useMediaQuery, SelectChangeEvent } from '@mui/material';
import Grid from '@mui/material/Grid2';
import Dropdown from 'components/Dropdown/Dropdown';

// Import Zustand store
import { useAppStore } from '../../stores';

interface IRoleDropdownProps {
  isNewUser: boolean;
  id: string;
  selectedPropsValue: string | number | undefined;
  setSelectedPropsValue: (value: number) => void;
  setSelectedPropsText: (text: string) => void;
  onDropdownChange: (e: SelectChangeEvent<string>) => void;
  selectedUser: {
    memberId?: string;
    affPinNum?: string;
    user?: {
      userId: number;
      firstName: string;
      lastName: string;
      username: string;
    };
    role: {
      roleId: number;
      roleName: string;
    };
  };
}

interface RoleItem {
  roleId: number;
  roleName: string;
}

const RoleDropdown: React.FC<IRoleDropdownProps> = (props) => {
  const displayMobile = useMediaQuery('(max-width:959px)');

  // Zustand store
  const roles = useAppStore(
    (state) => state.rolesAndPermissions.roles
  ) as RoleItem[];

  React.useEffect(() => {
    props.setSelectedPropsValue(props.selectedUser.role.roleId);
  }, [props.selectedUser.role.roleId, props]);

  const isNewUser = props.isNewUser;
  return (
    <Grid container direction="row" alignItems="center">
      {!isNewUser && (
        <Grid size={{ xs: 12, md: 3 }}>
          <span className="account-creation-input-label">Select a Role</span>
        </Grid>
      )}
      <Grid
        size={{ xs: 12, md: isNewUser ? 12 : 9 }}
        className={`${displayMobile && !isNewUser && 'pt-2'}`}
      >
        <Dropdown
          id={'user-management-role-dropdown'}
          required={true}
          selectedPropsValue={props.selectedUser.role.roleId > 0 ? String(props.selectedUser.role.roleId) : ''}
          name={'roleDropdown'}
          onChange={props.onDropdownChange}
          label={'Roles'}
          values={[
            <option key="blank" value="">— Select a role —</option>,
            ...roles.map((role: RoleItem, index: number) => (
              <option key={index} value={role.roleId}>
                {role.roleName}
              </option>
            )),
          ]}
        />
      </Grid>
    </Grid>
  );
};

export default RoleDropdown;
